module.exports = "/assets/kinley-page/cocktail_1@2x.jpg?QfWCG5Q";